module.exports = __webpack_public_path__ + "img/adv_team.cccb8942.png";